__webpack_require__.p = "/b/a/ecom-order-portal/976a2102d2af1b01b43df97444e41c47b281ccdd/_next/";